import messages from "./messages";
import recommendations from "./recommendations";

export default {
  messages,
  recommendations,
};
